import React from 'react';
import type { Swiper as SwiperType } from 'swiper';
import { useTheme } from 'styled-components';
import { getOpacity } from '../../../theme/utils/get-rgb';

interface SlideshowPaginationPropsInterface {
    instance: SwiperType | undefined;
    selectedIndex: number;
    variant: 'primary' | 'positive';
    dotsCount: number;
}

export const SlideshowPagination: React.FC<SlideshowPaginationPropsInterface> = ({
    instance,
    selectedIndex,
    dotsCount,
    variant,
}) => {
    const theme = useTheme();

    return instance ? (
        <div className="mx-medium mt-medium flex items-center justify-center gap-small [&:empty]:hidden">
            {Array.from({ length: dotsCount }).map((_, index: number) => (
                <div
                    className="relative h-[1.4rem] w-[1.4rem] rounded-full"
                    key={index}
                    onClick={() => instance.slideTo(index)}
                    style={{
                        background:
                            index === selectedIndex
                                ? theme.palette.color[variant].dark
                                : getOpacity(theme.palette.color[variant].dark, 0.5),
                    }}
                >
                    {index === selectedIndex && (
                        <span
                            className="pointer-events-none absolute h-[2.4rem] w-[2.4rem] rounded-full border"
                            style={{
                                borderColor: theme.palette.color[variant].dark,
                                bottom: `-${theme.gap.xxsmall}`,
                                right: `-${theme.gap.xxsmall}`,
                            }}
                        />
                    )}
                </div>
            ))}
        </div>
    ) : null;
};
